export default __webpack_public_path__ + "static/subset-UniNeueThin-d3d73556667b44dac564b1668b564e0a.woff";